import { observable, computed, action } from 'mobx';
import { sumBy } from 'lodash';
export class Xp {
	// @observable _shouldUpdate = false;

	// @computed get updating() {
	// 	return this._shouldUpdate;
	// }
	@observable leveledUp = false;

	@observable delay = 0;
	@observable duration = 0.5;

	@observable previousXp = 0;
	@observable previousXpStart = 0;
	@observable previousXpNext = 0;
	@observable previousLevel = 0;

	@computed get previousPercentage() {
		return ((this.previousXp - this.previousXpStart) / (this.previousXpNext - this.previousXpStart)) * 100;
	}

	@observable currentXp = 0;
	@observable currentXpStart = 0;
	@observable currentXpNext = 0;
	@observable currentLevel = 0;
	@observable currentState = '';

	@computed get currentProgress() {
		return [this.currentXp - this.currentXpStart, this.currentXpNext - this.currentXpStart];
	}

	@computed get currentPercentage() {
		return ((this.currentXp - this.currentXpStart) / (this.currentXpNext - this.currentXpStart)) * 100;
	}

	@action.bound nextStep(increaseLevel = false, delay = 0, duration = 0.5) {
		this.delay = delay;
		this.duration = duration;

		this.previousXp = this.currentXp;
		this.previousXpNext = this.currentXpNext;
		this.previousXpStart = this.currentXpStart;
		this.previousLevel = this.currentLevel;

		//If we need to level up.
		if (increaseLevel && this.currentXp === this._target.start) {
			this.currentLevel = this._target.level;
			this.currentXpStart = this._target.start;
			this.currentXpNext = this._target.next;
			this.currentState = 'increment-lvl';
			this.leveledUp = true;
			return this.currentState;
			
		} else if (this.currentXp < this._target.xp) {
			this.currentState = 'update-xp';
			return this.currentState;
		}
		//nothing changed
		this.currentState = 'xp-current';
		return this.currentState;
	}

	//used to set values immediately to the completed state.
	@action.bound setComplete() {
		this.currentXp = this._target.xp;
		this.currentXpNext = this._target.next;
		this.currentXpStart = this._target.start;
		this.currentLevel = this._target.level;

		this.previousXp = this.currentXp;
		this.previousXpNext = this.currentXpNext;
		this.previousXpStart = this.currentXpStart;
		this.previousLevel = this.currentLevel;
	}

	@observable _target = {
		xp: 0,
		level: 0,
		start: 0,
		next: 0,
	};

	@action.bound updateFromServer(data, immediate) {
		console.log('XP DATA', data);
		data = window.fakeData || data;
		this._target.xp = sumBy(data.Progress, 'Quantity');
		this._target.next = sumBy(data.Next, 'Quantity');
		this._target.start = sumBy(data.Start, 'Quantity');
		this._target.level = data.Current.Quantity;

		if (immediate) {
			this.setComplete();
		}
		console.log('7111 --- XPData - updated from server :: lvl =', this.currentLevel, 'up =', this.leveledUp, 'cur =', this.currentXp, 'anim =', this._target.xp, '\n\t all =', window.toJS(this))
	}
}
